export default __webpack_public_path__ + "static/media/core.2feeaaff.svg";